export default "__VITE_ASSET__CYpS3ZV0__"